var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-green",staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n    Enter multiple IP ranges, one per line. Examples for IP Ranges are as follows:\n\n        "),_c('li',[_vm._v("10.20.108.9 - 10.20.108.255")]),_vm._v(" "),_c('li',[_vm._v("10.20.30.* - 10.20.80.*")]),_vm._v(" "),_c('li',[_vm._v("10.20.30.*")])]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"rows":"10","placeholder":"Enter IP Ranges"}})])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/paywall/sessions/sections/IpRange.vue